{
  "0_ALREADY_EXISTS": "\"{0}\" ya existe.",
  "0_OF_1": "{0} de {1}",
  "ACCOUNT_ID": "ID de cuenta",
  "ADD": "Agregar",
  "ADD_REMOVE_FIELDS": "Agregar/eliminar campos",
  "AN_ERROR_OCCURED": "Ocurrió un error",
  "APPLY": "Aplicar",
  "APPLY_CHANGES": "Aplicar cambios",
  "ATTACH": "Adjuntar",
  "ATTACH_AS_LINK": "Adjuntar como enlace",
  "ATTACHING": "Adjuntando...",
  "AUTOMATICALLY_RENAME": "Renombrar automáticamente",
  "BACK": "Atrás",
  "BROWSE": "Examinar",
  "CANCEL": "Cancelar",
  "CHARACTER_COUNT": "Conteo de caracteres:",
  "CLOSE": "Cerrar",
  "CLOUD": "Cloud",
  "COMMENT": "Comentario",
  "CONFIGURE_REPOSITORY_SETTINGS": "Configurar ajustes del repositorio",
  "COULD_NOT_SAVE_0": "No se pudo guardar \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "No se pudo guardar \"{0}\". Tipo de archivo no soportado.",
  "DATA": "Datos",
  "DATE": "Fecha",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Los campos de fecha deben tener el formato {0}.",
  "DATE_PROVIDED_IS_INVALID": "La fecha proporcionada no es válida.",
  "DATE_TIME": "Fecha/Hora",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Los campos de fecha/hora deben tener el formato {0}.",
  "DEFAULT_FOLDER": "<Carpeta predeterminada>",
  "DETAILS": "Detalles",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "¿Desea aplicar los cambios en el campo?",
  "DOCUMENT_NAME_IS_EMPTY": "El nombre del documento está vacío",
  "DRAG_DROP_FILE": "Arrastre y suelte el archivo",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Ya existe una entrada llamada '{0}' en esta carpeta. Por favor seleccione un nombre diferente.",
  "ENTRY_ID": "ID de entrada",
  "ENTRY_NAME": "Nombre de entrada",
  "ENTRY_NOT_FOUND": "Entrada no encontrada.",
  "ERROR_DOWNLOADING_DOCUMENT": "Error al descargar el documento.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Ocurrió un error al conectar con el servidor.",
  "ERROR_SAVING": "Error al guardar:",
  "FAILED_TO_OPEN_FOLDER": "Error al abrir la carpeta",
  "FAILED_TO_SAVE_COLON": "Error al guardar:",
  "FAILED_TO_SAVE_PERIOD": "Error al guardar.",
  "FEEDBACK": "Comentarios",
  "FIELDS": "Campos",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Este archivo excede el tamaño máximo de archivo de 25MB.",
  "FILE_EXTENSION": "Extensión de archivo",
  "FILE_LOCKED": "El archivo está bloqueado.",
  "FILE_MODIFIED": "Archivo modificado",
  "FILE_NAME": "Nombre del archivo",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Los nombres de archivo no pueden contener una barra invertida",
  "FOLDER": "Carpeta",
  "INTEGER": "Entero",
  "LIST": "Lista",
  "LOADING": "Cargando...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Los campos Long deben ser enteros entre 0 y 3,999,999,999",
  "LONG_INTEGER": "Entero largo",
  "NAME": "Nombre",
  "NAME_CONFLICT": "Conflicto de nombre",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "¿Necesita ayuda para iniciar sesión? Contacte a su administrador de Laserfiche para obtener ayuda.",
  "NEW_FOLDER": "Nueva carpeta",
  "NO": "No",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "No se asignaron campos adicionales",
  "NO_FOLDER_SELECTED": "No se ha seleccionado ninguna carpeta.",
  "NO_MATCHING_ENTRIES_FOUND": "No se encontraron entradas coincidentes",
  "NO_MATCHING_FIELDS_FOUND": "No se encontraron campos coincidentes.",
  "NO_TEMPLATE_ASSIGNED": "No se asignó plantilla",
  "NOT_AVAILABLE_WITH_TOKENS": "No disponible con tokens",
  "NUMBER": "Número",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "El campo numérico debe ser un número válido",
  "OK": "Aceptar",
  "ONE_OR_MORE_FIELDS_INVALID": "Uno o más campos son inválidos.",
  "OPEN": "Abrir",
  "OPEN_IN_LASERFICHE": "Abrir en Laserfiche",
  "OPTIONAL": "Opcional",
  "OR": "o",
  "PARENT_FIELD": "Campo principal",
  "PARENT_ID": "ID del padre",
  "PARENT_NAME": "Nombre principal",
  "PLEASE_SELECT_A_FOLDER": "Por favor seleccione una carpeta",
  "REASON_FOR_DOWNLOADING": "Razón para descargar",
  "REFRESH": "Actualizar",
  "REMOVE": "Eliminar",
  "REMOVE_REPOSITORY": "¿Eliminar repositorio?",
  "REPOSITORY": "Repositorio",
  "REPOSITORY_COUNT": "Cantidad de repositorios",
  "REPOSITORY_ID": "ID del repositorio",
  "REPOSITORY_NAME": "Nombre del repositorio",
  "REQUIRED": "Obligatorio",
  "REQUIRED_FIELD_IS_EMPTY": "El campo obligatorio está vacío",
  "SAVE_CHANGES": "Guardar cambios",
  "SAVE_TO_LASERFICHE": "Guardar en Laserfiche",
  "SAVED_TO_LASERFICHE": "Guardado en Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Guardado en Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Guardado con metadatos faltantes:",
  "SAVING": "Guardando...",
  "SEARCH_FIELDS": "Campos de búsqueda",
  "SELECT": "Seleccionar",
  "SELECT_REASON": "Seleccione una razón",
  "SELF_HOSTED": "Autoalojado",
  "SESSION_COUNT": "Conteo de sesiones",
  "SETTINGS": "Configuración",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Los campos Short deben ser enteros entre 0 y 64999",
  "SIGN_IN": "Iniciar sesión",
  "SIGN_IN_TO_LASERFICHE": "Iniciar sesión en Laserfiche",
  "SIGN_OUT": "Cerrar sesión",
  "SIGNING_IN": "Iniciando sesión...",
  "SIGNING_OUT": "Cerrando sesión...",
  "SKIP_THIS_FILE": "Omitir este archivo",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Algo salió mal. Por favor intente de nuevo más tarde.",
  "SUBMIT": "Enviar",
  "SUGGESTION": "Sugerencia",
  "TEMPLATE": "Plantilla",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "La plantilla no se pudo cargar.",
  "TEXT": "Texto",
  "THANK_YOU_FOR_SUBMISSION": "¡Gracias por su envío!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Este campo tiene una longitud máxima permitida de {0} caracteres.",
  "THIS_FOLDER_IS_EMPTY": "Esta carpeta está vacía.",
  "TIME": "Hora",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Los campos de hora deben tener el formato {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "No se pudieron cargar todos los campos:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "No se pudo obtener la información del repositorio:",
  "UNKNOWN_ERROR": "Error desconocido.",
  "USER_NAME": "Nombre de usuario",
  "YES": "Sí"
}
